import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';

import './desktop-main-header-style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';

// Components
import { ImageButton } from '@atoms';
import Button from '@src/componentsNew/Buttons/Button';
import MenuIcon from '@src/componentsNew/Icons/Icons/MenuIcon';
import SearchIcon from '@src/componentsNew/Icons/Icons/SearchIcon';
import WishlistIcon from '@src/componentsNew/Icons/Icons/WishlistIcon';
import CartQuantityIcon from '@src/componentsNew/Icons/CartQuantityIcon/CartQuantityIcon';
import AccountIcon from '@src/componentsNew/Icons/Icons/AccountIcon';

// images & icons
import Logo from '@src/imagesNew/logo/maccaron-logo.jpg';
import GlobalStoreLogo from '@src/imagesNew/logo/global-store-logo.png';

import { credentialType, CredentialContext, MenuDataContext } from '@src/providers';

// constants
import { goToUrl } from '@src/utils/urlCheck';
import { goToGlobalStore } from '@src/utils/domainCheck';
import { baseUrl, brandListUrl, searchUrl, wishListUrl, cartUrl, accountUrl, accountLoginUrl } from '@src/app/routes';

const DesktopMainHeader = () => {
  const history = useHistory();
  const isComDomain = useIsComDomain();
  const { currentUser } = useContext<credentialType>(CredentialContext);
  const { categoryItems, MGSBtnUrl, saleBtnUrl } = useContext(MenuDataContext);

  const [isCategoryBtnHovered, setIsCategoryBtnHovered] = useState(false);
  const [activeCategoryZeroLevel, setActiveCategoryZeroLevel] = useState(null);
  const [activeCategoryOneLevel, setActiveCategoryOneLevel] = useState(null);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const currentElement = event.target;
      const elementClass = currentElement?.className;

      if (typeof elementClass === 'string' && !elementClass?.includes('category-hover-area')) {
        setIsCategoryBtnHovered(false);
        setActiveCategoryZeroLevel(null);
        setActiveCategoryOneLevel(null);
      }
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  useEffect(() => {
    // url 변경 시, 카테고리 리스트 영역이 안보이도록.
    setIsCategoryBtnHovered(false);
    setActiveCategoryZeroLevel(null);
    setActiveCategoryOneLevel(null);
  }, [history.location]);

  const handleCategoryBtnMouseOver = () => {
    setIsCategoryBtnHovered(true);
  };

  const handleMouseOverCategoryLevelZero = (level) => {
    setActiveCategoryZeroLevel(level);
    setActiveCategoryOneLevel(null);
  };

  return (
    <header id="desktop-main-header" className="category-hover-area">
      <div className="desktop-header-content-wrapper">
        <div className="button-wrapper category-hover-area">
          <Button
            size="medium"
            cName="category-hover-area"
            startIcon={<MenuIcon strokeColor="#212121" />}
            onMouseOver={handleCategoryBtnMouseOver}
          >
            Category
          </Button>
          <Button size="medium" onClick={() => history.push(brandListUrl)}>
            Brand
          </Button>
          {isComDomain ? null : (
            <Button size="medium" onClick={() => goToUrl(history, saleBtnUrl)}>
              Offers
            </Button>
          )}
          {isComDomain ? null : (
            // Domain Revert Comment
            // <Button size="medium" cName="two-color-text" onClick={(e) => goToGlobalStore(e, true)}>
            //   MGS
            //   <span className="light-text">Global Store</span>
            // </Button>
            <Button size="medium" cName="two-color-text" onClick={() => goToUrl(history, MGSBtnUrl)}>
              MGS
              <span className="light-text">Global Store</span>
            </Button>
          )}
        </div>

        <ImageButton
          className="logo-btn"
          href={baseUrl}
          imgSrc={isComDomain ? GlobalStoreLogo : Logo}
          width={isComDomain ? '230' : '150'}
        />

        <div className="icon-wrapper">
          <IconButton className="icon-btn" onClick={() => history.push(searchUrl)}>
            <SearchIcon />
          </IconButton>
          {currentUser ? (
            <IconButton className="icon-btn" onClick={() => history.push(accountUrl)}>
              <AccountIcon />
            </IconButton>
          ) : null}
          <IconButton className="icon-btn" onClick={() => history.push(wishListUrl)}>
            <WishlistIcon />
          </IconButton>
          <IconButton className="icon-btn" onClick={() => history.push(cartUrl)}>
            <CartQuantityIcon />
          </IconButton>
          {currentUser ? null : (
            <Button size="medium" onClick={() => history.push(accountLoginUrl)}>
              Log-In / Sign-Up
            </Button>
          )}
        </div>
      </div>

      {isCategoryBtnHovered && (
        <div className="category-container category-hover-area">
          <div className="category-wrapper category-hover-area">
            <div className="level0-wrapper category-hover-area">
              {categoryItems?.map((level0, idx) => (
                <Button
                  key={idx}
                  size="medium"
                  onMouseOver={() => handleMouseOverCategoryLevelZero(level0)}
                  cName={`level0-btn category-hover-area ${activeCategoryZeroLevel === level0 ? 'active' : ''}`}
                >
                  {level0.name}
                </Button>
              ))}
            </div>
            {activeCategoryZeroLevel && (
              <div className="level1-wrapper category-hover-area">
                {activeCategoryZeroLevel?.child_items?.map((level1, idx) => (
                  <Button
                    key={idx}
                    size="medium"
                    cName={`level1-btn category-hover-area ${activeCategoryOneLevel === level1 ? 'active' : ''}`}
                    onMouseOver={() => setActiveCategoryOneLevel(level1)}
                    onClick={() => goToUrl(history, level1.url)}
                  >
                    {level1.name}
                  </Button>
                ))}
              </div>
            )}
            {activeCategoryOneLevel && (
              <div className="level2-wrapper category-hover-area">
                {activeCategoryOneLevel?.child_items?.map((level2, idx) => (
                  <Button
                    key={idx}
                    size="medium"
                    cName="level2-btn category-hover-area"
                    onClick={() => goToUrl(history, level2.url)}
                  >
                    {level2.name}
                  </Button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default DesktopMainHeader;
